import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';

export type BudgetLengthDetails = {
  isDailyLengthBudget: boolean;
  isWeeklyLengthBudget: boolean;
  isMonthlyLengthBudget: boolean;
  isCustomLengthBudget: boolean;
  isMultiDaysLengthBudget: boolean;
  isMonthAvailable: boolean;
};

export const getBudgetLengthDetails = (
  budgetLength: MealCreditLength,
  budgetResetType: BudgetResetTypeValues
): BudgetLengthDetails => {
  const isDailyLengthBudget = budgetLength === MealCreditLength.DAILY;
  const isWeeklyLengthBudget = budgetLength === MealCreditLength.WEEKLY;
  const isMonthlyLengthBudget = budgetLength === MealCreditLength.MONTHLY;
  const isCustomLengthBudget = budgetLength === MealCreditLength.CUSTOM;

  const isMultiDaysLengthBudget =
    isWeeklyLengthBudget || isCustomLengthBudget || isMonthlyLengthBudget;

  const isCustomMonthsLengthBudget =
    isCustomLengthBudget && budgetResetType === BudgetResetTypeValues.MONTHS;

  const isMonthAvailable = isMonthlyLengthBudget || isCustomMonthsLengthBudget;

  return {
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    isCustomLengthBudget,
    isMultiDaysLengthBudget,
    isMonthAvailable,
  };
};
